// -------------------------------------------------------------------------------------------------------------------
// common function to talk to the Gateway backend server
// -------------------------------------------------------------------------------------------------------------------

import { fetchAuthSession } from 'aws-amplify/auth';
import { ACCESS, CRQ, SUBMIT_CRQ, FORCE_SIGNED_OUT_COMMS_ERROR } from '../common/constants';

export function makeGatewayApi({ gatewayUrl, getJwt, setJwt, signOut }) {
  // if the currentAccessJwt has expired, get (via Amplify), set and return a new one, otherwise return currentAccessJwt
  const updatedToken = async () => {
    const currentAccessJwt = getJwt();
    if (!currentAccessJwt) {
      console.warn('updatedToken: no JWT available');
      return null;
    }
    if ((Date.now() / 1000) > parseJwt(currentAccessJwt).exp) {
      // Amplify call returns user session with a refreshed access token (provided the session's refresh token is still valid)
      const currentSession = await fetchAuthSession();
      const newToken = currentSession.tokens.accessToken.toString();
      setJwt(newToken);
      return newToken;
    } else {
      return currentAccessJwt;
    }
  };

  const parseJwt = (token) => {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
    return JSON.parse(jsonPayload);
  };

  const getFormData = (object) => {
    const formData = new FormData();
    Object.keys(object || {}).forEach(key => formData.append(key, object[key]));
    return formData;
  };

  return async function fetchDataFromGateway(type, request) {
    const token = await updatedToken();
    if (!token) {
      console.warn('fetchDataFromGateway: skipping call, no JWT token', { type, gatewayUrl });
      return null;
    }
    const requestFormData = (type === SUBMIT_CRQ) ? request : getFormData(request);
    const result = await fetch(gatewayUrl + type, {
      method: 'POST',
      headers: { 'Authorization': 'JWT ' + token },
      body: requestFormData,
    });
    if ((!result) || (result.status === 403)) {
      return signOut(FORCE_SIGNED_OUT_COMMS_ERROR);
    }
    return (type === CRQ)
      ? await result.text().catch(e => console.log(e))
      : await result.json().catch(e => console.log(e));
  };
}
